// services/BillingInvoiceService.ts

import { AxiosInstance } from "axios";
import { APIResponse } from "@/customTypes/NetworkTypes";
import NetworkUtil from "@/projectUtils/NetworkUtil";
import { apiEndpoints } from "./axiosConfig/AxiosServiceConstants";
import { iBillingInvoiceRequest } from "@/redux/addBilllingDetails/Types";


function BillingInvoiceService(apiServer: AxiosInstance) {

  const getToken = (): string | null => {
    return localStorage.getItem("userToken");
  };

  const addBillingDetails = async (
    data: iBillingInvoiceRequest
  ): Promise<APIResponse<null>> => {
    let result: APIResponse<null>;

    const token = getToken();

    await apiServer
      .post(apiEndpoints.addBillingDetails.addBillingDetails(), data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
      .then(
        (value) => {
          result = NetworkUtil.buildResult(null, value.status, null, value.data);
        },
        (reason) => {
          const { response } = reason;
          const { status, data } = response;
          result = NetworkUtil.buildResult(data, status, data, null);
        }
      )
      .catch((error) => {
        throw error;
      });

    return result!;
  };

  return {
    addBillingDetails,
  };
}

export default BillingInvoiceService;
